<div class="confirmation-validation-container">

    <!-- LEFT -->
    <div class="columns-mapping-container">

        <span class="label-title">Prévia mapa</span>
        <div class="preview-map-container">
            <app-import-wizard-geospatial-minimap></app-import-wizard-geospatial-minimap>
        </div>

        <ng-container *ngIf="!isMultifeature">
            <ul>
                <span class="label-title">Nome da coluna</span> 
                <li *ngFor="let col of displayColumns(); let i = index; trackBy: trackByColumnIndex;">
                    <span>{{ col.name }}</span>

                    <!-- <span
                        style="color: var(--color-primary); font-weight: bold; text-transform: uppercase;"
                    >
                        {{ getLabelByValue(col.type) }}
                    </span> -->
                </li>
            </ul>
        </ng-container>

        <ng-container *ngIf="isMultifeature">
            <ul>
                <span class="label-title">Nome das Camadas</span> 
                <li *ngFor="let lay of importJobFiles(); let i = index; trackBy: trackByLayersIndex;">
                    <span>{{lay.filename.split('.')[0]}}</span>
                </li>
            </ul>
        </ng-container>
        
    </div>

    <!-- RIGHT -->
    <div class="preview-tabular-container">

        <div class="errors-wrapper">

            <!-- CARREGANDO -->
            <ng-container *ngIf="isLoading()">
            </ng-container>

            <!-- CARREGADO -->
            <ng-container *ngIf="!isLoading()">
                <!-- COM ERROS -->
                <ng-container *ngIf="groupedErrors().length > 0 || total()! > 0; else noErrorsTemplate">

                    <ng-container *ngIf="!showDetailedErrors()">
                        <div style="position: absolute; top: 1rem; right: 1rem; z-index: 10;">
                            <button
                                class="secondary"
                                (click)="toggleDetailedErrors()"
                                style="padding: 6px 16px; background: #333; color: #fff; border: 1px solid #444; border-radius: 6px; cursor: pointer;"
                            >
                                Ver erros
                            </button>
                        </div>

                        <app-status-page
                            [mainTitle]="'Erros de Validação'"
                            [description]="'Foram encontrados erros de validação nos dados.\nEm caso de dúvidas, entre em contato com o nosso suporte através do email: <b>contato@forestoken.com.br</b>, ou clique em &quot;Ver erros&quot; para mais detalhes.'"
                            [variant]="'error'"
                            *ngIf="!isLoading()"
                        ></app-status-page>
                    </ng-container>

                    <ng-container *ngIf="showDetailedErrors()">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                            <h6 *ngIf="showErrorsSectionTitle()" style="margin: 0;">
                                As seguintes linhas apresentam erros:
                            </h6>
                            <button
                                class="secondary"
                                (click)="toggleDetailedErrors()"
                                style="padding: 6px 16px; background: #333; color: #fff; border: 1px solid #444; border-radius: 6px; cursor: pointer;"
                            >
                                Ocultar Erros
                            </button>
                        </div>

                        <div class="validation-errors">
                            <div
                                class="error-group"
                                *ngFor="let error of groupedErrors(); let i = index"
                                [class.invalid-file-group]="error.is_invalid_file"
                                [style.animationDelay.ms]="i * 80"
                            >
                                <ng-container *ngIf="!error.is_invalid_file; else invalidFile">
                                    <div class="error-group-header">
                                        <div class="error-title">
                                            <span class="error-column">Coluna "{{ error.column_name }}"</span>
                                            <span class="error-count">{{ error.rows.length }} linha(s) com erro nesta página</span>
                                        </div>
                                    </div>
                                    <div class="error-description">
                                        Os valores abaixo não correspondem ao tipo selecionado.
                                    </div>
                                    <div class="error-rows">
                                        <div class="error-row-item" *ngFor="let row of error.rows; let idx = index">
                                            <span class="row-number">Linha {{ row }}</span>
                                            <span class="row-value">
                                                {{ error.values[idx] != ' ' ? '"' + error.values[idx] + '"' : 'Valor é um espaço (" ")' }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-template #invalidFile>
                                    <app-status-page
                                        [mainTitle]="'Muitos erros encontrados'"
                                        [description]="error.error_message"
                                        [variant]="'error'"
                                    ></app-status-page>
                                </ng-template>
                            </div>
                        </div>

                        <mat-paginator
                            *ngIf="showErrorsSectionTitle()"
                            [length]="total()"
                            [pageSize]="pageSize()"
                            [pageSizeOptions]="pageSizesArray"
                            aria-label="Selecione a pagina"
                            [showFirstLastButtons]="true"
                            (page)="handlePageChange($event)"
                        ></mat-paginator>
                    </ng-container>

                </ng-container>

                <!-- SEM ERROS -->
                <ng-template #noErrorsTemplate>

                    <!-- PROCESSANDO / CONCLUÍDO -->
                    <ng-container *ngIf="isFinishing || isCompleted(); else readyTemplate">
                        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; gap: 20px; padding: 32px 24px;">

                            <!-- Barra de progresso -->
                            <div style="width: 100%;">
                                <div style="display: flex; justify-content: space-between; align-items: center; font-size: 13px; font-weight: 500; color: #444; margin-bottom: 10px;">
                                    <span style="display: flex; align-items: center; gap: 7px;">
                                        <ng-container *ngIf="progressPhase() === 'upload'">
                                            <ng-icon name="lucideUploadCloud" style="font-size: 16px; color: var(--color-primary);"></ng-icon>
                                            {{ hasOccurrences ? 'Etapa 1/2 — Enviando arquivo' : 'Enviando arquivo' }}
                                        </ng-container>
                                        <ng-container *ngIf="progressPhase() === 'rail'">
                                            <ng-icon name="lucideNetwork" style="font-size: 16px; color: var(--color-primary);"></ng-icon>
                                            Etapa 2/2 — Processando dados
                                        </ng-container>
                                        <ng-container *ngIf="progressPhase() === 'done' && isCompleted()">
                                            <ng-icon name="lucideCircleCheck" style="font-size: 16px; color: #2e7d32;"></ng-icon>
                                            Concluído
                                        </ng-container>
                                        <ng-container *ngIf="!progressPhase() && !isCompleted()">Iniciando...</ng-container>
                                    </span>
                                    <span style="font-size: 13px; font-weight: 600; color: var(--color-primary);">{{ (createRepositoryLoadingProgress | async) | number:'1.0-0' }}%</span>
                                </div>
                                <mat-progress-bar
                                    mode="determinate"
                                    [value]="createRepositoryLoadingProgress | async"
                                    style="width: 100%; border-radius: 4px; --mdc-linear-progress-active-indicator-color: var(--color-primary); --mdc-linear-progress-track-color: rgba(245, 113, 11, 0.15);"
                                ></mat-progress-bar>
                            </div>

                            <!-- Mensagem de progresso -->
                            <p *ngIf="progressMessage() && !successMessage() && !errorMessage()"
                               style="margin: 0; font-size: 13px; color: #555; text-align: center;">
                                {{ progressMessage() }}
                            </p>

                            <!-- Sucesso -->
                            <div
                                *ngIf="successMessage() && !errorMessage()"
                                role="status"
                                style="width: 100%; padding: 14px 16px; background: #e6f4ea; color: #1e4620; border: 1px solid #b7dfc0; border-radius: 6px; font-size: 13px;"
                            >
                                <strong>Importação concluída com sucesso.</strong>
                                <div style="margin-top: 6px;">{{ successMessage() }}</div>
                            </div>

                            <!-- Checkbox: adicionar ao mapa -->
                            <div *ngIf="successMessage() && !errorMessage() && hasOccurrences" style="margin-top: 16px; display: flex; flex-direction: column; gap: 6px;">
                                <label style="display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer;">
                                    <input
                                        type="checkbox"
                                        [(ngModel)]="addToMapAfterFinish"
                                        style="width: 15px; height: 15px; accent-color: var(--color-primary); cursor: pointer;"
                                    >
                                    Deseja adicionar essa camada no mapa?
                                </label>
                                <p *ngIf="!addToMapAfterFinish" style="margin: 0; font-size: 11px; color: #888;">
                                    Você poderá adicionar manualmente na tela de repositórios.
                                </p>
                            </div>

                            <!-- Erro -->
                            <div
                                *ngIf="errorMessage()"
                                role="alert"
                                style="width: 100%; padding: 14px 16px; background: #fdecea; color: #611a15; border: 1px solid #f5c2c0; border-radius: 6px; font-size: 13px;"
                            >
                                <strong>Falha ao concluir a importação:</strong>
                                <div style="margin-top: 6px;">{{ errorMessage() }}</div>
                                <button
                                    class="primary"
                                    (click)="handleRetryClick()"
                                    style="margin-top: 12px; padding: 6px 16px;"
                                >
                                    Tentar novamente
                                </button>
                            </div>

                        </div>
                    </ng-container>

                    <!-- PRONTO PARA IMPORTAR -->
                    <ng-template #readyTemplate>
                        <app-status-page
                            [mainTitle]="'Nenhum erro encontrado'"
                            [description]="'Os dados são válidos e prontos para finalizar a importação.'"
                            [variant]="'success'"
                        ></app-status-page>
                    </ng-template>

                </ng-template>

            </ng-container>
        </div>
    </div>

    <!-- ================= BUTTONS ================= -->
    <div class="button-container">
        <button
            class="secondary"
            (click)="handleCancelClick()"
            [disabled]="isFinishing || isCompleted()"
        >
            Descartar Importação
        </button>

        <button
            class="primary"
            (click)="handleButtonClick()"
            [disabled]="isFinishing || (!isCompleted() && groupedErrors().length > 0)"
            [innerText]="isCompleted() ? 'Sair' : (isFinishing ? 'Importando...' : 'Concluir Importação')"
        ></button>
    </div>

</div>

<app-alert
    title="Cancelar importação"
    message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
    confirmText="Confirmar"
    cancelText="Voltar"
    [visible]="isAlertVisible"
    (onConfirmEvent)="handleCancelClickConfirmation()"
    (onCancelEvent)="handleCancelClickCancel()"
></app-alert>